export default "__VITE_ASSET__DZ3eU_h9__ 1920w";